var _a;
import createRollDice from './rollDice';
import createTallyRolls from './tallyRolls';
import calculateFinalResult from './calculateFinalResult';
import createRoll from './roll';
import createTokenize from './tokenize';
import simpleDieRoll from './rules/simpleDieRoll';
import constant from './rules/constant';
import { getDefaultRollConfigOptions, } from './util/rollConfig';
export var defaultPlugins = (_a = {},
    _a[simpleDieRoll.typeConstant] = simpleDieRoll,
    _a[constant.typeConstant] = constant,
    _a);
function createDiceRoller(plugins, configOverrides) {
    if (plugins === void 0) { plugins = defaultPlugins; }
    if (configOverrides === void 0) { configOverrides = {}; }
    var rollConfig = getDefaultRollConfigOptions(configOverrides);
    var _a = createTokenize(plugins, rollConfig), tokenize = _a.tokenize, tokenizeFaultTolerant = _a.tokenizeFaultTolerant;
    var rollDice = createRollDice(plugins, rollConfig);
    var tallyRolls = createTallyRolls(plugins, rollConfig);
    return {
        tokenize: tokenize,
        tokenizeFaultTolerant: tokenizeFaultTolerant,
        calculateFinalResult: calculateFinalResult,
        rollDice: rollDice,
        tallyRolls: tallyRolls,
        roll: createRoll(tokenize, rollDice, tallyRolls, rollConfig),
    };
}
export default createDiceRoller;
